import React, { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { ButtonFixedLayout } from "../../../../components/ButtonFixedLayout";
import { DataCard } from "../../../../components/DataCard";
import { InputFloatingLabel } from "../../../../components/InputFloatingLabel";
import { useButtonPosition } from "../../../../utils/buttonPositionByScreenSize";

interface IProps {
	isLoading: boolean;
	hasCPFError: boolean;
	cleanCPFError: VoidFunction;
	onSubmit(cpf: string): Promise<void>;
}

const strings = {
	submitButton: "Continuar",
	input: {
		cpf: {
			label: "CPF",
			placeholder: "XXX.XXX.XXX-XX",
			messageError: "CPF inválido. Dá uma conferida",
		},
	},
	entryCPFStep: {
		title: "Agora, digite seu CPF",
		description: "Informe seu CPF para iniciar ou acompanhar seu empréstimo",
	},
};
export const EntryCPFStep: React.FC<IProps> = observer((props) => {
	const { onSubmit, isLoading, hasCPFError, cleanCPFError } = props;
	const [cpf, setCpf] = useState<string>("");

	const cpfError = cpf.length < 14 && cpf.length !== 0 || hasCPFError;
	const cpfSuccess = cpf.length === 14 && !hasCPFError;

	const handleSubmit = useCallback(() => {
		onSubmit(cpf);
	}, [cpf, onSubmit]);

	const screenSizeLimit = 400;
	const buttonPosition = useButtonPosition(screenSizeLimit);

	useEffect(() => {
		if (hasCPFError) {
			cleanCPFError();
		}
	}, [cpf]);

	return (
		<ButtonFixedLayout
			buttonStyles={{
				position: buttonPosition,
			}}
			primaryButton={{
				title: strings.submitButton,
				onClick: handleSubmit,
				variant: "solid",
				disabled: !cpfSuccess || isLoading,
			}}
			isFixed
		>
			<>
				<DataCard
					title={strings.entryCPFStep.title}
					description={strings.entryCPFStep.description}
				>
					<InputFloatingLabel
						type='cpf'
						value={cpf}
						setValue={setCpf}
						isError={cpfError}
						isSuccess={cpfSuccess}
						label={strings.input.cpf.label}
						placeholder={strings.input.cpf.placeholder}
						messageError={strings.input.cpf.messageError}
						hasIcon
					/>
				</DataCard>
			</>
		</ButtonFixedLayout>
	);
});
